import {
	Pipe,
	PipeTransform
} from '@angular/core';

/**
 * This pipe removes everything from url in <a> tag if tag contains df-portal-link class or
 * href contains management-ui/ otherwise do not change anything.
 * Return <a> tag without href attribute, add data-link attribute with href
 */
@Pipe( {
	name: 'externalToInternalLink',
	standalone: true
} )
export class ExternalToInternalLinkPipe implements PipeTransform {
	transform( value: string ): string {
		if ( value && value.length > 1 ) {
			let aClass = 'df-portal-link';
			let searchString = 'management-ui/';

			return value.replace( /<a\s+[^>]*?href="([^"]*)"([^"]*)>([^"]*)<\/a>/g, ( match, href ) => {
				if ( match.includes( aClass ) || href.includes( searchString ) ) {
					let pos = href.indexOf( searchString );
					if ( pos > -1 ) {
						let url = href.slice( pos + searchString.length );
						let aContent = match.replace( /(<[^>]+>)/g, '' );
						return `<a class="${ aClass }" data-url="${ url }">${ aContent }</a>`;
					}
					return match;
				}
				return match;
			} );
		}

	}
}
